const products = {
  // Reliability
  RELIABILITY_NEW_REPORT: 'reliabilityNewReport',
  RELIABILITY_REPORT: 'reliabilityReport',
  RELIABILITY_ACTUALIZE: 'reliabilityActualize',
  RELIABILITY_URGENCY: 'reliabilityUrgency',
  RELIABILITY_CONSULTATION: 'reliabilityConsultation',

  // Objects
  OBJECT_PREMIUM7: 'objectPremium7',
  OBJECT_PREMIUM14: 'objectPremium14',
  OBJECT_PREMIUM30: 'objectPremium30',
  OBJECT_TOP3_7: 'objectTop37',
  OBJECT_TOP3_14: 'objectTop314',
  OBJECT_TOP3_30: 'objectTop330',
  OBJECT_FREE: 'objectFree',

  // Wallet
  WALLET: 'wallet'
};

export default products;
